import { createApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";
import { EcoFeeSettings } from "./types";
import { transformEcoFeeSettings } from "./transformation";

/*---------------------------------------------------------------------------------------
  ECO FEE SETTINGS - GET
-----------------------------------------------------------------------------------------*/
export const getEcoFeeSettingsAPI = async (): Promise<EcoFeeSettings> => {
  const response = await createApiCall(
    {
      path: "/v1/settings/eco-fee",
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformEcoFeeSettings(response.data);
};

/*---------------------------------------------------------------------------------------
  ECO FEE SETTINGS - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateEcoFeeSettingsAPI = async (
  formValues: EcoFeeSettings,
  t: (key: string) => string
): Promise<EcoFeeSettings> => {
  const response = await createApiCall(
    {
      path: "/v1/settings/eco-fee",
      method: "PUT",
      body: {
        perKgRate: formValues.perKgRate,
        driverMassDeductionKg: formValues.driverMassDeductionKg,
        fuelMassDeductionKg: formValues.fuelMassDeductionKg,
        tireFeeM1: formValues.tireFeeM1,
        tireFeeN1: formValues.tireFeeN1,
      },
    },
    {
      getMessage: {
        success: () => t("admin.settings.ecofee.message.update"),
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformEcoFeeSettings(response.data);
};
